import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

export default function LatestNews() {
  const recentArticles = getRecentArticles(6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新资讯
            </h2>
            <p className="text-foreground-500 text-sm mt-2">深度体育分析与赛事解读</p>
          </div>
          <Link
            to="/category/zuqiu"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recentArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}